export const getNormalizedPhoneLength = (phoneValue: string) => {
    return [...phoneValue.replaceAll(' ', '')].map(Number).filter(el=>!Number.isNaN(el)).length;
};